module.exports = __webpack_public_path__ + "media/icons/switch_green-af34aad3.png";